import * as React from 'react';
import { useState } from 'react';
import { Field, Form } from 'formik';
import * as Yup from 'yup';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';
import Select from '~/common/controls/Select';

import { UserRole } from '../../consts';


const ROLE_OPTIONS = [
  {
    label: 'Clerk',
    value: UserRole.CLERK,
  },
  {
    label: 'Agent',
    value: UserRole.AGENT,
  },
];

const forcePass = true;


const UserSchema = Yup.object().shape({
  username: Yup.string()
    .required('Required'),
  role: Yup.string().required('Required'),
  // locationId: Yup.string().required('Required'),
  password: Yup.string().required('Required'),
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
});


const UserCreateForm = (props) => {
  const { error, onSubmit, locations } = props;
  const [forcePassword, serForcePassword] = useState(forcePass);
  const initialValues = {
    username: '',
    password: '',
    role: UserRole.CLERK,
    locationId: null,
    firstName: '',
    lastName: '',
    forcePasswordChange: forcePass,
  };

  const cbChange = (field, check) => {
    serForcePassword(!forcePassword);
  };


  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={(data) => onSubmit(UserSchema.cast(data))}
      validationSchema={UserSchema}
      render={(props) => {

        return (
          <Form className="form__cont">
            <Field
              name="username"
              label="Username"
              type="text"
              component={Input}
              className="input input--bubble"
              autoComplete="off"
              value=""
            />
            <Field
              name="password"
              label="Password"
              type="password"
              component={Input}
              className="input input--bubble"
            />
            <Field
              name="role"
              label="Role"
              component={Select}
              options={ROLE_OPTIONS}
              className="input input--bubble input--bubble--withdrop"
            />
            <Field
              name="locationId"
              label="Location"
              component={Select}
              options={locations}
              className="input input--bubble"
            />
            <Field
              name="firstName"
              label="First Name"
              type="text"
              component={Input}
              className="input input--bubble"
            />
            <Field
              name="lastName"
              label="Last Name"
              type="text"
              component={Input}
              className="input input--bubble"
            />
            <div className="input--checkbox--inline">
              <Field
                name="forcePasswordChange"
                label="Force password change"
                className="input--checkbox"
                type="checkbox"
                cbChange={cbChange}
                checked={forcePassword}
                component={Input}
              />
            </div>

            {error && <div className="form__note">{error}</div>}

            <button className="btn btn--prim btn--lg" type="submit">
              Submit
            </button>
          </Form>
        );
      }}
    />
  );
};

export default UserCreateForm;
